import api from '../config';
import URLS from '../../constants/urls';
export const _getLocationsBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.LOCATION}/${siteId}/get-locations?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
export const _createLocation = async (data) => {
    const response = await api.post(`${URLS.LOCATION}/create`, data);
    return response.data;
};
export const _updateLocation = async (siteId, locationId, data) => {
    const response = await api.put(`${URLS.LOCATION}/update/${siteId}/${locationId}`, data);
    return response.data;
};
export const _listLocation = async (siteId) => {
    const response = await api.get(`${URLS.LOCATION}/${siteId}/get-locations`);
    return response.data;
};
export const _deleteLocation = async (siteId, locationId) => {
    const response = await api.delete(`${URLS.LOCATION}/delete/${siteId}/${locationId}`);
    return response.data;
};
export const _downloadExcelForLocation = (siteId) => {
    return api.get(`${URLS.LOCATION}/${siteId}/download`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/octet-stream',
        },
    });
};
export const _uploadExcelForLocation = (siteId, data) => {
    const response = api.post(`${URLS.LOCATION}/${siteId}/upload`, data);
    return response;
};
